import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RecordsService } from '../services/records.service';
import { Record } from '../model/record';

@Component({
  selector: 'app-searchterm',
  templateUrl: './searchterm.component.html',
  styleUrls: ['./searchterm.component.css']
})
export class SearchtermComponent implements OnInit {

  CurrentPage:number = 0;
  TotalPages:number;
  Links: string;
  link: string;
  records: Record;
  size: number =10;
  term: string;
  type: string;
  

  constructor(private RecordService: RecordsService,private router: Router, private activatedroute: ActivatedRoute) { }

  ngOnInit(): void {
    this.term = this.activatedroute.snapshot.params.term;
    this.type =this.activatedroute.snapshot.params.type;
    console.log(this.term);
    //this.OnPageSearch(this.term);
  }
  

  // onPageRecord(page: string) {
  //   this.link = page;
  //   this.RecordService.getRecordsBypage(this.link)
  //     .subscribe(
  //       data => {
  //         this.TotalPages = data["page"].totalPages;
  //         this.CurrentPage = data["page"].number;
  //         this.Links = data["_links"];
  //         this.records = data["_embedded"].recordses;
  //       }, err => {
  //         console.log(err);
  //     }
  //   )
  // }

}